// source: witbooking/backoffice/propertyconfiguration/v1/propertyconfiguration_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js');
goog.object.extend(proto, witbooking_backoffice_common_common_pb);
var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.Configuration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.EngineBookingAdvantagesPositionType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.EngineDisplayModeType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.EngineResultsFormatType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.displayName = 'proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse.displayName = 'proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.displayName = 'proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse.displayName = 'proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest.displayName = 'proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.displayName = 'proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.displayName = 'proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.displayName = 'proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertyconfiguration.v1.Configuration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.displayName = 'proto.witbooking.backoffice.propertyconfiguration.v1.Configuration';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    configuration: (f = msg.getConfiguration()) && proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest;
  return proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.propertyconfiguration.v1.Configuration;
      reader.readMessage(value,proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.serializeBinaryToWriter
    );
  }
};


/**
 * optional Configuration configuration = 1;
 * @return {?proto.witbooking.backoffice.propertyconfiguration.v1.Configuration}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.prototype.getConfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.propertyconfiguration.v1.Configuration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.propertyconfiguration.v1.Configuration, 1));
};


/**
 * @param {?proto.witbooking.backoffice.propertyconfiguration.v1.Configuration|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse;
  return proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    engineappearance: (f = msg.getEngineappearance()) && proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest;
  return proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance;
      reader.readMessage(value,proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.deserializeBinaryFromReader);
      msg.setEngineappearance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEngineappearance();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.serializeBinaryToWriter
    );
  }
};


/**
 * optional EngineAppearance engineAppearance = 1;
 * @return {?proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.prototype.getEngineappearance = function() {
  return /** @type{?proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance, 1));
};


/**
 * @param {?proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.prototype.setEngineappearance = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.prototype.clearEngineappearance = function() {
  return this.setEngineappearance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest.prototype.hasEngineappearance = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse;
  return proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest;
  return proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    configuration: (f = msg.getConfiguration()) && proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse;
  return proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.propertyconfiguration.v1.Configuration;
      reader.readMessage(value,proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.serializeBinaryToWriter
    );
  }
};


/**
 * optional Configuration configuration = 1;
 * @return {?proto.witbooking.backoffice.propertyconfiguration.v1.Configuration}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.prototype.getConfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.propertyconfiguration.v1.Configuration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.propertyconfiguration.v1.Configuration, 1));
};


/**
 * @param {?proto.witbooking.backoffice.propertyconfiguration.v1.Configuration|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.prototype.setConfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.toObject = function(includeInstance, msg) {
  var f, obj = {
    brand: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider;
  return proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string brand = 1;
 * @return {string}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.toObject = function(includeInstance, msg) {
  var f, obj = {
    darkmode: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    palette: (f = msg.getPalette()) && witbooking_backoffice_common_common_pb.Palette.toObject(includeInstance, f),
    typographyconfiguration: (f = msg.getTypographyconfiguration()) && witbooking_backoffice_common_common_pb.TypographyConfiguration.toObject(includeInstance, f),
    mobiletypographyconfiguration: (f = msg.getMobiletypographyconfiguration()) && witbooking_backoffice_common_common_pb.TypographyConfiguration.toObject(includeInstance, f),
    iconpack: (f = msg.getIconpack()) && witbooking_backoffice_common_common_pb.IconPack.toObject(includeInstance, f),
    accommodationresultsformattype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    inventoryresultsformattype: jspb.Message.getFieldWithDefault(msg, 7, 0),
    displaymode: jspb.Message.getFieldWithDefault(msg, 8, 0),
    bookingadvantagesposition: jspb.Message.getFieldWithDefault(msg, 9, 0),
    bookingadvantagesloyaltymodule: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    buttonroundtype: jspb.Message.getFieldWithDefault(msg, 11, 0),
    tagroundtype: jspb.Message.getFieldWithDefault(msg, 12, 0),
    bookingformroundtype: jspb.Message.getFieldWithDefault(msg, 13, 0),
    cardroundtype: jspb.Message.getFieldWithDefault(msg, 14, 0),
    formroundtype: jspb.Message.getFieldWithDefault(msg, 15, 0),
    bookingformborder: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    bookingadvantagesicon: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
    headercolor: (f = msg.getHeadercolor()) && witbooking_backoffice_common_common_pb.Colors.toObject(includeInstance, f),
    bodycolor: (f = msg.getBodycolor()) && witbooking_backoffice_common_common_pb.Colors.toObject(includeInstance, f),
    buttoncolor: (f = msg.getButtoncolor()) && witbooking_backoffice_common_common_pb.Colors.toObject(includeInstance, f),
    tagcolor: (f = msg.getTagcolor()) && witbooking_backoffice_common_common_pb.Colors.toObject(includeInstance, f),
    bookingadvantagescolor: (f = msg.getBookingadvantagescolor()) && witbooking_backoffice_common_common_pb.Colors.toObject(includeInstance, f),
    logo: (f = msg.getLogo()) && witbooking_backoffice_common_common_pb.Multimedia.toObject(includeInstance, f),
    mobilelogo: (f = msg.getMobilelogo()) && witbooking_backoffice_common_common_pb.Multimedia.toObject(includeInstance, f),
    emaillogo: (f = msg.getEmaillogo()) && witbooking_backoffice_common_common_pb.Multimedia.toObject(includeInstance, f),
    favicon: (f = msg.getFavicon()) && witbooking_backoffice_common_common_pb.Multimedia.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance;
  return proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDarkmode(value);
      break;
    case 2:
      var value = new witbooking_backoffice_common_common_pb.Palette;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Palette.deserializeBinaryFromReader);
      msg.setPalette(value);
      break;
    case 3:
      var value = new witbooking_backoffice_common_common_pb.TypographyConfiguration;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.TypographyConfiguration.deserializeBinaryFromReader);
      msg.setTypographyconfiguration(value);
      break;
    case 4:
      var value = new witbooking_backoffice_common_common_pb.TypographyConfiguration;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.TypographyConfiguration.deserializeBinaryFromReader);
      msg.setMobiletypographyconfiguration(value);
      break;
    case 5:
      var value = new witbooking_backoffice_common_common_pb.IconPack;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.IconPack.deserializeBinaryFromReader);
      msg.setIconpack(value);
      break;
    case 6:
      var value = /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineResultsFormatType} */ (reader.readEnum());
      msg.setAccommodationresultsformattype(value);
      break;
    case 7:
      var value = /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineResultsFormatType} */ (reader.readEnum());
      msg.setInventoryresultsformattype(value);
      break;
    case 8:
      var value = /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineDisplayModeType} */ (reader.readEnum());
      msg.setDisplaymode(value);
      break;
    case 9:
      var value = /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineBookingAdvantagesPositionType} */ (reader.readEnum());
      msg.setBookingadvantagesposition(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBookingadvantagesloyaltymodule(value);
      break;
    case 11:
      var value = /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} */ (reader.readEnum());
      msg.setButtonroundtype(value);
      break;
    case 12:
      var value = /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} */ (reader.readEnum());
      msg.setTagroundtype(value);
      break;
    case 13:
      var value = /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} */ (reader.readEnum());
      msg.setBookingformroundtype(value);
      break;
    case 14:
      var value = /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} */ (reader.readEnum());
      msg.setCardroundtype(value);
      break;
    case 15:
      var value = /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} */ (reader.readEnum());
      msg.setFormroundtype(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBookingformborder(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBookingadvantagesicon(value);
      break;
    case 18:
      var value = new witbooking_backoffice_common_common_pb.Colors;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Colors.deserializeBinaryFromReader);
      msg.setHeadercolor(value);
      break;
    case 19:
      var value = new witbooking_backoffice_common_common_pb.Colors;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Colors.deserializeBinaryFromReader);
      msg.setBodycolor(value);
      break;
    case 20:
      var value = new witbooking_backoffice_common_common_pb.Colors;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Colors.deserializeBinaryFromReader);
      msg.setButtoncolor(value);
      break;
    case 21:
      var value = new witbooking_backoffice_common_common_pb.Colors;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Colors.deserializeBinaryFromReader);
      msg.setTagcolor(value);
      break;
    case 22:
      var value = new witbooking_backoffice_common_common_pb.Colors;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Colors.deserializeBinaryFromReader);
      msg.setBookingadvantagescolor(value);
      break;
    case 23:
      var value = new witbooking_backoffice_common_common_pb.Multimedia;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Multimedia.deserializeBinaryFromReader);
      msg.setLogo(value);
      break;
    case 24:
      var value = new witbooking_backoffice_common_common_pb.Multimedia;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Multimedia.deserializeBinaryFromReader);
      msg.setMobilelogo(value);
      break;
    case 25:
      var value = new witbooking_backoffice_common_common_pb.Multimedia;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Multimedia.deserializeBinaryFromReader);
      msg.setEmaillogo(value);
      break;
    case 26:
      var value = new witbooking_backoffice_common_common_pb.Multimedia;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Multimedia.deserializeBinaryFromReader);
      msg.setFavicon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDarkmode();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPalette();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      witbooking_backoffice_common_common_pb.Palette.serializeBinaryToWriter
    );
  }
  f = message.getTypographyconfiguration();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      witbooking_backoffice_common_common_pb.TypographyConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getMobiletypographyconfiguration();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      witbooking_backoffice_common_common_pb.TypographyConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getIconpack();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      witbooking_backoffice_common_common_pb.IconPack.serializeBinaryToWriter
    );
  }
  f = message.getAccommodationresultsformattype();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getInventoryresultsformattype();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getDisplaymode();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getBookingadvantagesposition();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getBookingadvantagesloyaltymodule();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getButtonroundtype();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getTagroundtype();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getBookingformroundtype();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getCardroundtype();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getFormroundtype();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getBookingformborder();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getBookingadvantagesicon();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getHeadercolor();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      witbooking_backoffice_common_common_pb.Colors.serializeBinaryToWriter
    );
  }
  f = message.getBodycolor();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      witbooking_backoffice_common_common_pb.Colors.serializeBinaryToWriter
    );
  }
  f = message.getButtoncolor();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      witbooking_backoffice_common_common_pb.Colors.serializeBinaryToWriter
    );
  }
  f = message.getTagcolor();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      witbooking_backoffice_common_common_pb.Colors.serializeBinaryToWriter
    );
  }
  f = message.getBookingadvantagescolor();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      witbooking_backoffice_common_common_pb.Colors.serializeBinaryToWriter
    );
  }
  f = message.getLogo();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      witbooking_backoffice_common_common_pb.Multimedia.serializeBinaryToWriter
    );
  }
  f = message.getMobilelogo();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      witbooking_backoffice_common_common_pb.Multimedia.serializeBinaryToWriter
    );
  }
  f = message.getEmaillogo();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      witbooking_backoffice_common_common_pb.Multimedia.serializeBinaryToWriter
    );
  }
  f = message.getFavicon();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      witbooking_backoffice_common_common_pb.Multimedia.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool darkMode = 1;
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getDarkmode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setDarkmode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional witbooking.backoffice.common.Palette palette = 2;
 * @return {?proto.witbooking.backoffice.common.Palette}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getPalette = function() {
  return /** @type{?proto.witbooking.backoffice.common.Palette} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Palette, 2));
};


/**
 * @param {?proto.witbooking.backoffice.common.Palette|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setPalette = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearPalette = function() {
  return this.setPalette(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasPalette = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional witbooking.backoffice.common.TypographyConfiguration typographyConfiguration = 3;
 * @return {?proto.witbooking.backoffice.common.TypographyConfiguration}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getTypographyconfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyConfiguration} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.TypographyConfiguration, 3));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyConfiguration|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setTypographyconfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearTypographyconfiguration = function() {
  return this.setTypographyconfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasTypographyconfiguration = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional witbooking.backoffice.common.TypographyConfiguration mobileTypographyConfiguration = 4;
 * @return {?proto.witbooking.backoffice.common.TypographyConfiguration}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getMobiletypographyconfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyConfiguration} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.TypographyConfiguration, 4));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyConfiguration|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setMobiletypographyconfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearMobiletypographyconfiguration = function() {
  return this.setMobiletypographyconfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasMobiletypographyconfiguration = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional witbooking.backoffice.common.IconPack iconPack = 5;
 * @return {?proto.witbooking.backoffice.common.IconPack}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getIconpack = function() {
  return /** @type{?proto.witbooking.backoffice.common.IconPack} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.IconPack, 5));
};


/**
 * @param {?proto.witbooking.backoffice.common.IconPack|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setIconpack = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearIconpack = function() {
  return this.setIconpack(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasIconpack = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional EngineResultsFormatType accommodationResultsFormatType = 6;
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineResultsFormatType}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getAccommodationresultsformattype = function() {
  return /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineResultsFormatType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineResultsFormatType} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setAccommodationresultsformattype = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional EngineResultsFormatType inventoryResultsFormatType = 7;
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineResultsFormatType}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getInventoryresultsformattype = function() {
  return /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineResultsFormatType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineResultsFormatType} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setInventoryresultsformattype = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional EngineDisplayModeType displayMode = 8;
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineDisplayModeType}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getDisplaymode = function() {
  return /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineDisplayModeType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineDisplayModeType} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setDisplaymode = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional EngineBookingAdvantagesPositionType bookingAdvantagesPosition = 9;
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineBookingAdvantagesPositionType}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getBookingadvantagesposition = function() {
  return /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineBookingAdvantagesPositionType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineBookingAdvantagesPositionType} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setBookingadvantagesposition = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional bool bookingAdvantagesLoyaltyModule = 10;
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getBookingadvantagesloyaltymodule = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setBookingadvantagesloyaltymodule = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional EngineRoundType buttonRoundType = 11;
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getButtonroundtype = function() {
  return /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setButtonroundtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional EngineRoundType tagRoundType = 12;
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getTagroundtype = function() {
  return /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setTagroundtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional EngineRoundType bookingFormRoundType = 13;
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getBookingformroundtype = function() {
  return /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setBookingformroundtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional EngineRoundType cardRoundType = 14;
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getCardroundtype = function() {
  return /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setCardroundtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional EngineRoundType formRoundType = 15;
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getFormroundtype = function() {
  return /** @type {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setFormroundtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional bool bookingFormBorder = 16;
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getBookingformborder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setBookingformborder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional bool bookingAdvantagesIcon = 17;
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getBookingadvantagesicon = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setBookingadvantagesicon = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional witbooking.backoffice.common.Colors headerColor = 18;
 * @return {?proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getHeadercolor = function() {
  return /** @type{?proto.witbooking.backoffice.common.Colors} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Colors, 18));
};


/**
 * @param {?proto.witbooking.backoffice.common.Colors|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setHeadercolor = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearHeadercolor = function() {
  return this.setHeadercolor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasHeadercolor = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional witbooking.backoffice.common.Colors bodyColor = 19;
 * @return {?proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getBodycolor = function() {
  return /** @type{?proto.witbooking.backoffice.common.Colors} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Colors, 19));
};


/**
 * @param {?proto.witbooking.backoffice.common.Colors|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setBodycolor = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearBodycolor = function() {
  return this.setBodycolor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasBodycolor = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional witbooking.backoffice.common.Colors buttonColor = 20;
 * @return {?proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getButtoncolor = function() {
  return /** @type{?proto.witbooking.backoffice.common.Colors} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Colors, 20));
};


/**
 * @param {?proto.witbooking.backoffice.common.Colors|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setButtoncolor = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearButtoncolor = function() {
  return this.setButtoncolor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasButtoncolor = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional witbooking.backoffice.common.Colors tagColor = 21;
 * @return {?proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getTagcolor = function() {
  return /** @type{?proto.witbooking.backoffice.common.Colors} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Colors, 21));
};


/**
 * @param {?proto.witbooking.backoffice.common.Colors|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setTagcolor = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearTagcolor = function() {
  return this.setTagcolor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasTagcolor = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional witbooking.backoffice.common.Colors bookingAdvantagesColor = 22;
 * @return {?proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getBookingadvantagescolor = function() {
  return /** @type{?proto.witbooking.backoffice.common.Colors} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Colors, 22));
};


/**
 * @param {?proto.witbooking.backoffice.common.Colors|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setBookingadvantagescolor = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearBookingadvantagescolor = function() {
  return this.setBookingadvantagescolor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasBookingadvantagescolor = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional witbooking.backoffice.common.Multimedia logo = 23;
 * @return {?proto.witbooking.backoffice.common.Multimedia}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getLogo = function() {
  return /** @type{?proto.witbooking.backoffice.common.Multimedia} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Multimedia, 23));
};


/**
 * @param {?proto.witbooking.backoffice.common.Multimedia|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setLogo = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearLogo = function() {
  return this.setLogo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasLogo = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional witbooking.backoffice.common.Multimedia mobileLogo = 24;
 * @return {?proto.witbooking.backoffice.common.Multimedia}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getMobilelogo = function() {
  return /** @type{?proto.witbooking.backoffice.common.Multimedia} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Multimedia, 24));
};


/**
 * @param {?proto.witbooking.backoffice.common.Multimedia|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setMobilelogo = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearMobilelogo = function() {
  return this.setMobilelogo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasMobilelogo = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional witbooking.backoffice.common.Multimedia emailLogo = 25;
 * @return {?proto.witbooking.backoffice.common.Multimedia}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getEmaillogo = function() {
  return /** @type{?proto.witbooking.backoffice.common.Multimedia} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Multimedia, 25));
};


/**
 * @param {?proto.witbooking.backoffice.common.Multimedia|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setEmaillogo = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearEmaillogo = function() {
  return this.setEmaillogo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasEmaillogo = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional witbooking.backoffice.common.Multimedia favicon = 26;
 * @return {?proto.witbooking.backoffice.common.Multimedia}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.getFavicon = function() {
  return /** @type{?proto.witbooking.backoffice.common.Multimedia} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Multimedia, 26));
};


/**
 * @param {?proto.witbooking.backoffice.common.Multimedia|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.setFavicon = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.clearFavicon = function() {
  return this.setFavicon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.prototype.hasFavicon = function() {
  return jspb.Message.getField(this, 26) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.Configuration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.toObject = function(includeInstance, msg) {
  var f, obj = {
    engineprovider: (f = msg.getEngineprovider()) && proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.toObject(includeInstance, f),
    engineappearance: (f = msg.getEngineappearance()) && proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.Configuration}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertyconfiguration.v1.Configuration;
  return proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.Configuration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.Configuration}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider;
      reader.readMessage(value,proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.deserializeBinaryFromReader);
      msg.setEngineprovider(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance;
      reader.readMessage(value,proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.deserializeBinaryFromReader);
      msg.setEngineappearance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.Configuration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEngineprovider();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider.serializeBinaryToWriter
    );
  }
  f = message.getEngineappearance();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance.serializeBinaryToWriter
    );
  }
};


/**
 * optional EngineProvider engineProvider = 1;
 * @return {?proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.prototype.getEngineprovider = function() {
  return /** @type{?proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider, 1));
};


/**
 * @param {?proto.witbooking.backoffice.propertyconfiguration.v1.EngineProvider|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.Configuration} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.prototype.setEngineprovider = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.Configuration} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.prototype.clearEngineprovider = function() {
  return this.setEngineprovider(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.prototype.hasEngineprovider = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EngineAppearance engineAppearance = 2;
 * @return {?proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.prototype.getEngineappearance = function() {
  return /** @type{?proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance, 2));
};


/**
 * @param {?proto.witbooking.backoffice.propertyconfiguration.v1.EngineAppearance|undefined} value
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.Configuration} returns this
*/
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.prototype.setEngineappearance = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertyconfiguration.v1.Configuration} returns this
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.prototype.clearEngineappearance = function() {
  return this.setEngineappearance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.Configuration.prototype.hasEngineappearance = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineResultsFormatType = {
  ENGINE_RESULTS_FORMAT_TYPE_EMPTY: 0,
  AUTO: 1,
  GRID: 2,
  LIST: 3
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineDisplayModeType = {
  ENGINE_DISPLAY_MODE_TYPE_EMPTY: 0,
  SIDEBAR: 1,
  EXTENDED: 2
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineBookingAdvantagesPositionType = {
  ENGINE_BOOKING_ADVANTAGES_POSITION_TYPE_EMPTY: 0,
  TOP: 1,
  BOTTOM: 2
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.propertyconfiguration.v1.EngineRoundType = {
  ENGINE_ROUND_TYPE_EMPTY: 0,
  ZERO: 1,
  DEFAULT: 2,
  MD: 3,
  LG: 4,
  XL: 5,
  XXL: 6,
  XXXL: 7,
  FULL: 8
};

goog.object.extend(exports, proto.witbooking.backoffice.propertyconfiguration.v1);
